export interface MediaUploadResponse {
  media_url: string;
  filename: string;
  size: number;
  content_type?: string;
}

export interface MediaUploadOptions {
  folder?: string;
  maxSize?: number;
  allowedTypes?: string[];
}

export const DEFAULT_UPLOAD_OPTIONS: MediaUploadOptions = {
  folder: 'general',
  maxSize: 5 * 1024 * 1024, // 5MB
  allowedTypes: ['image/jpeg', 'image/jpg', 'image/png'],
};